import React from 'react';
import PropTypes from 'prop-types';

const RecentSearches = ({ recentSearches, handleSearchTerm, search }) => (
  <div className="list list--search">
    <div className="header header--list">
      <h2>Recent searches</h2>
    </div>
    {[...recentSearches].reverse().map(searchedTerm => (
      <div
        key={searchedTerm}
        role="button"
        className="list__item list__item--search"
        onClick={() => {
          handleSearchTerm({ target: { value: searchedTerm } });
          search({ value: searchedTerm });
        }}>
        <div className="list__item-row list__item-row--search">
          <i className="material-icons">search</i>
          <div className="list__item-text list__item-text--search">{searchedTerm}</div>
        </div>
      </div>
    ))}
  </div>
);

RecentSearches.propTypes = {
  recentSearches: PropTypes.array.isRequired,
  handleSearchTerm: PropTypes.func.isRequired,
  search: PropTypes.func.isRequired
};

export default RecentSearches;
